module.exports = __webpack_public_path__ + "static/img/img_jtdt.6489c1a9.png";